import styled from 'styled-components';
import Button from '@nebula/button';

export const CTAButton = styled(Button)<{ 'aria-label'?: string }>`
  width: 100%;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  text-align: center;
  font-size: 0.875rem;
`;

export const VoucherButton = styled(Button)`
  width: 100%;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
`;

export const CTAStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  width: 100%;
`;

export const CurrentLabel = styled.p`
  width: 100%;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25rem;
  color: #384553;
`;
